/**
 * Géographie de la République Démocratique du Congo
 * 26 provinces administratives et leurs villes principales
 */

export interface Province {
  code: string;
  name: string;
  capital: string;
  cities: string[];
}

/**
 * Liste des 26 provinces de la RDC avec leurs villes principales
 */
export const RDC_PROVINCES: Province[] = [
  {
    code: 'KIN',
    name: 'Kinshasa',
    capital: 'Kinshasa',
    cities: [
      'Kinshasa',
      'Gombe',
      'Lingwala',
      'Barumbu',
      'Kinshasa',
      'Kintambo',
      'Ngaliema',
      'Mont-Ngafula',
      'Selembao',
      'Bumbu',
      'Makala',
      'Ngiri-Ngiri',
      'Kalamu',
      'Lemba',
      'Limete',
      'Matete',
      'Ngaba',
      'Kisenso',
      'Kimbanseke',
      'Masina',
      'Ndjili',
      'Nsele',
      'Maluku'
    ]
  },
  {
    code: 'KOC',
    name: 'Kongo-Central',
    capital: 'Matadi',
    cities: [
      'Matadi',
      'Boma',
      'Muanda',
      'Mbanza-Ngungu',
      'Kisantu',
      'Lukala',
      'Songololo',
      'Tshela',
      'Moanda',
      'Inga',
      'Seke-Banza',
      'Luozi',
      'Kasangulu'
    ]
  },
  {
    code: 'KWA',
    name: 'Kwango',
    capital: 'Kenge',
    cities: [
      'Kenge',
      'Popokabaka',
      'Kasongo-Lunda',
      'Kahemba',
      'Feshi'
    ]
  },
  {
    code: 'KWI',
    name: 'Kwilu',
    capital: 'Kikwit',
    cities: [
      'Kikwit',
      'Idiofa',
      'Bulungu',
      'Masi-Manimba',
      'Bagata',
      'Gungu'
    ]
  },
  {
    code: 'MAI',
    name: 'Maï-Ndombe',
    capital: 'Inongo',
    cities: [
      'Inongo',
      'Kutu',
      'Bikoro',
      'Bolobo',
      'Mushie',
      'Kiri',
      'Yumbi'
    ]
  },
  {
    code: 'EQU',
    name: 'Équateur',
    capital: 'Mbandaka',
    cities: [
      'Mbandaka',
      'Bikoro',
      'Bomongo',
      'Bolomba',
      'Basankusu',
      'Ingende',
      'Befale',
      'Djolu'
    ]
  },
  {
    code: 'SUD',
    name: 'Sud-Ubangi',
    capital: 'Gemena',
    cities: [
      'Gemena',
      'Libenge',
      'Kungu',
      'Budjala',
      'Zongo'
    ]
  },
  {
    code: 'NUB',
    name: 'Nord-Ubangi',
    capital: 'Gbadolite',
    cities: [
      'Gbadolite',
      'Mobayi-Mbongo',
      'Yakoma',
      'Businga'
    ]
  },
  {
    code: 'MON',
    name: 'Mongala',
    capital: 'Lisala',
    cities: [
      'Lisala',
      'Bumba',
      'Bongandanga'
    ]
  },
  {
    code: 'TSH',
    name: 'Tshuapa',
    capital: 'Boende',
    cities: [
      'Boende',
      'Befale',
      'Ikela',
      'Monkoto',
      'Bokungu'
    ]
  },
  {
    code: 'TUR',
    name: 'Tshopo',
    capital: 'Kisangani',
    cities: [
      'Kisangani',
      'Isangi',
      'Basoko',
      'Yahuma',
      'Opala',
      'Ubundu',
      'Bafwasende',
      'Banalia'
    ]
  },
  {
    code: 'BUA',
    name: 'Bas-Uélé',
    capital: 'Buta',
    cities: [
      'Buta',
      'Aketi',
      'Bondo',
      'Ango',
      'Poko',
      'Bambesa'
    ]
  },
  {
    code: 'HUE',
    name: 'Haut-Uélé',
    capital: 'Isiro',
    cities: [
      'Isiro',
      'Watsa',
      'Wamba',
      'Dungu',
      'Faradje',
      'Niangara',
      'Rungu'
    ]
  },
  {
    code: 'ITU',
    name: 'Ituri',
    capital: 'Bunia',
    cities: [
      'Bunia',
      'Aru',
      'Mahagi',
      'Djugu',
      'Irumu',
      'Mambasa'
    ]
  },
  {
    code: 'NKI',
    name: 'Nord-Kivu',
    capital: 'Goma',
    cities: [
      'Goma',
      'Butembo',
      'Beni',
      'Lubero',
      'Rutshuru',
      'Masisi',
      'Walikale',
      'Nyiragongo',
      'Oicha',
      'Kasindi'
    ]
  },
  {
    code: 'SKI',
    name: 'Sud-Kivu',
    capital: 'Bukavu',
    cities: [
      'Bukavu',
      'Uvira',
      'Kabare',
      'Walungu',
      'Kalehe',
      'Idjwi',
      'Mwenga',
      'Shabunda',
      'Fizi',
      'Kamituga',
      'Baraka'
    ]
  },
  {
    code: 'MAN',
    name: 'Maniema',
    capital: 'Kindu',
    cities: [
      'Kindu',
      'Kasongo',
      'Kabambare',
      'Pangi',
      'Lubutu',
      'Punia',
      'Kailo'
    ]
  },
  {
    code: 'HTK',
    name: 'Haut-Katanga',
    capital: 'Lubumbashi',
    cities: [
      'Lubumbashi',
      'Likasi',
      'Kipushi',
      'Kambove',
      'Sakania',
      'Pweto',
      'Kasumbalesa',
      'Mitwaba'
    ]
  },
  {
    code: 'LUA',
    name: 'Lualaba',
    capital: 'Kolwezi',
    cities: [
      'Kolwezi',
      'Dilolo',
      'Kapanga',
      'Sandoa',
      'Mutshatsha',
      'Fungurume'
    ]
  },
  {
    code: 'HLO',
    name: 'Haut-Lomami',
    capital: 'Kamina',
    cities: [
      'Kamina',
      'Kaniama',
      'Kabongo',
      'Malemba-Nkulu',
      'Bukama'
    ]
  },
  {
    code: 'TAN',
    name: 'Tanganyika',
    capital: 'Kalemie',
    cities: [
      'Kalemie',
      'Kongolo',
      'Moba',
      'Manono',
      'Kabalo',
      'Nyunzu'
    ]
  },
  {
    code: 'LOJ',
    name: 'Lomami',
    capital: 'Kabinda',
    cities: [
      'Kabinda',
      'Mwene-Ditu',
      'Ngandajika',
      'Lubao',
      'Luilu'
    ]
  },
  {
    code: 'SKA',
    name: 'Sankuru',
    capital: 'Lusambo',
    cities: [
      'Lusambo',
      'Lodja',
      'Katako-Kombe',
      'Lubefu',
      'Kole'
    ]
  },
  {
    code: 'KSO',
    name: 'Kasaï',
    capital: 'Tshikapa',
    cities: [
      'Tshikapa',
      'Ilebo',
      'Mweka',
      'Luebo',
      'Dekese',
      'Kamonia'
    ]
  },
  {
    code: 'KSC',
    name: 'Kasaï-Central',
    capital: 'Kananga',
    cities: [
      'Kananga',
      'Demba',
      'Dibaya',
      'Dimbelenge',
      'Luiza',
      'Kazumba'
    ]
  },
  {
    code: 'KSO',
    name: 'Kasaï-Oriental',
    capital: 'Mbuji-Mayi',
    cities: [
      'Mbuji-Mayi',
      'Tshilenge',
      'Miabi',
      'Kabeya-Kamwanga',
      'Katanda',
      'Lupatapata'
    ]
  }
];

/**
 * Liste aplatie de toutes les provinces (juste les noms)
 */
export const RDC_PROVINCE_NAMES: string[] = RDC_PROVINCES.map(p => p.name);

/**
 * Liste aplatie de toutes les villes de la RDC (dédupliquées et triées)
 */
export const RDC_ALL_CITIES: string[] = [
  ...new Set(RDC_PROVINCES.flatMap(p => p.cities))
].sort((a, b) => a.localeCompare(b, 'fr'));

/**
 * Obtenir les villes d'une province donnée
 */
export function getCitiesByProvince(provinceName: string): string[] {
  const province = RDC_PROVINCES.find(
    p => p.name.toLowerCase() === provinceName.toLowerCase()
  );
  return province ? province.cities : [];
}

/**
 * Obtenir la province d'une ville donnée
 */
export function getProvinceByCity(cityName: string): string | null {
  for (const province of RDC_PROVINCES) {
    if (province.cities.some(c => c.toLowerCase() === cityName.toLowerCase())) {
      return province.name;
    }
  }
  return null;
}

/**
 * Valeur spéciale pour "Autre" dans les dropdowns
 */
export const OTHER_OPTION = '__OTHER__';

/**
 * Options formatées pour un Select de province
 */
export const PROVINCE_OPTIONS = [
  ...RDC_PROVINCE_NAMES.map(name => ({ value: name, label: name })),
  { value: OTHER_OPTION, label: 'Autre (saisir manuellement)' }
];

/**
 * Obtenir les options de ville pour une province donnée
 */
export function getCityOptions(provinceName: string): { value: string; label: string }[] {
  const cities = getCitiesByProvince(provinceName);
  return [
    ...cities.map(city => ({ value: city, label: city })),
    { value: OTHER_OPTION, label: 'Autre (saisir manuellement)' }
  ];
}

/**
 * Toutes les villes disponibles (pour recherche/autocomplete)
 */
export const ALL_CITIES_OPTIONS = [
  ...RDC_ALL_CITIES.map(city => ({ value: city, label: city })),
  { value: OTHER_OPTION, label: 'Autre (saisir manuellement)' }
];
